<div class="row d-flex justify-content-center" >
    <button type="button" class="btn align-self-center" [class]="attributes.class ? attributes.class : 's'">
      {{attributes.label}}
    </button>
</div>